module.exports = __webpack_public_path__ + "725b834289cdecbf536d3799fba9be60.jpg";